import Box from "@mui/material/Box";
import React, { FC } from "react";
import { useLanguageDetails } from "../../context";
import { StyledPrimaryButton } from "./styled";

const ActionButtons: FC = () => {
  const { handleSaveLanguage, isDisabledSubmit, isSubmitting } =
    useLanguageDetails();

  return (
    <Box gap="1rem" display="flex" flexDirection="row" alignItems="center">
      <StyledPrimaryButton
        title="Save and Publish"
        size="small"
        disabled={isDisabledSubmit}
        onClick={handleSaveLanguage}
        loading={isSubmitting}
      />
    </Box>
  );
};

export default ActionButtons;
